import { StyleSheet } from 'aphrodite';
import { brandSecondary, grayIconFill, titles } from '../../../../web/styles/colors';
import { Layouts } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	calendarPopoverContent: {
		boxSizing: 'border-box',
		marginBottom: 20,
		padding: '10px 0',
	},
	calendarPopoverContentHeader: {
		alignItems: 'center',
		borderBottom: '1px solid #D8D8D8',
		display: 'flex',
		fontSize: 12,
		justifyContent: 'space-between',
		margin: '0 20px 20px 20px',
		padding: '10px 0',
	},
	comboboxChips: {
		width: '100%',
	},
	comboboxWrapper: {
		margin: '10px 0',
		width: 370,
	},
	inputTitle: {
		color: titles,
		fontSize: 14,
		margin: '10px 0 5px',
	},
	modalButtons: {
		marginTop: 20,
		...Layouts.horizontalStack(20),
	},
	modalTitle: {
		color: brandSecondary,
		fontSize: 18,
	},
	radio: {
		marginTop: 10,
	},
	selectedTime: {
		background: '#f9f9f9',
		color: grayIconFill,
		marginLeft: 20,
		padding: '8px 14px',
	},
	textBlack: {
		color: titles,
	},
	time: {
		alignItems: 'center',
		display: 'flex',
	},
});
